import Link from 'next/link';

import { useClientSmallScreen } from '@/lib/user-agent/client';

import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import { useGetSearchAdBanner } from '@/components/layout/services/hooks';

export default function AdBanner() {
  const { data } = useGetSearchAdBanner();
  const isMobile = useClientSmallScreen();
  const width = isMobile ? 366 : 640;
  const height = isMobile ? 125 : 133;
  const hasBanner = !!data?.status;

  const imageSrc = isMobile ? data?.mobile_image?.publicLink : data?.image?.publicLink;

  return (
    <Container className='mx-0 w-full rounded-lg px-5 pt-4 md:px-5'>
      <Container
      // style={{
      //   height: hasBanner ? height : 0,
      // }}
      // className='overflow-hidden transition-all duration-500 ease-in-out'
      >
        {hasBanner && (
          <Container
            id='search-ad-banner'
            className='animate-fadeIn w-full rounded-lg bg-[#EBEBEB]'
          >
            <Link href={data.link} prefetch={false}>
              <XImage
                src={imageSrc!}
                alt='search-ad-banner'
                width={width}
                height={height}
                className='rounded-lg'
              />
            </Link>
          </Container>
        )}
      </Container>
    </Container>
  );
}
